import { queryOptions, useQuery } from "@tanstack/react-query";

import { segmentsQueryKeys } from "./queryKeys";

import type { SegmentDetailResponse } from "@/features/segments/types";
import { instance } from "@/lib/axios/instance";

type UseSegmentDetailParams = {
  segmentId?: string;
  clientId?: string;
};

export const segmentDetailQueryOptions = ({
  segmentId,
  clientId,
}: UseSegmentDetailParams) =>
  queryOptions({
    queryKey: segmentsQueryKeys.detail(segmentId, clientId),
    queryFn: () =>
      instance
        .get<SegmentDetailResponse>(`/api/v2/Segments/${segmentId}`, {
          params: clientId ? { clientId } : {},
        })
        .then((res) => res.data),
    staleTime: 20 * 60 * 1000,
    refetchOnMount: true, // Overrides the global false so a `segment:*` realtime invalidation (api/realtime.ts) refetches on return
  });

export function useSegmentDetail({
  segmentId,
  clientId,
}: UseSegmentDetailParams) {
  return useQuery({
    ...segmentDetailQueryOptions({ segmentId, clientId }),
    enabled: Boolean(segmentId),
    refetchOnReconnect: false,
  });
}
